import type { ReactNode } from 'react';

const CanvasContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div
      style={{
        backgroundColor: '#161617',
        opacity: '1',
        backgroundImage:
          'linear-gradient(#3d3d3d 0.7000000000000001px, transparent 0.7000000000000001px), linear-gradient(to right, #3d3d3d 0.7000000000000001px, #161617 0.7000000000000001px)',
        backgroundSize: '14px 14px',
      }}
      className="relative mt-4 min-h-full w-full lg:mt-0"
      id="canvas-container"
    >
      {children}
    </div>
  );
};

export default CanvasContainer;
